import { useSearchParams } from 'react-router-dom';
import type { VideoSummary } from '@streamr/shared';
import { VideoGrid } from '../components/VideoGrid';
import { flattenPages, useSearch } from '../api/hooks/useDiscovery';
import { EmptyState } from '../components/ui';

export const SearchPage = (): JSX.Element => {
  const [params] = useSearchParams();
  const q = params.get('q') ?? '';
  const results = useSearch(q);

  if (q.trim() === '') {
    return <EmptyState title="Search Streamr" hint="Type something into the box above." />;
  }

  return (
    <div>
      <h1 className="mb-6 text-xl font-semibold">
        Results for <span className="text-ink-300">{q}</span>
      </h1>
      <VideoGrid
        videos={flattenPages<VideoSummary>(results.data)}
        isLoading={results.isLoading}
        error={results.error}
        hasNextPage={results.hasNextPage}
        isFetchingNextPage={results.isFetchingNextPage}
        fetchNextPage={() => void results.fetchNextPage()}
        emptyTitle="No matches"
        emptyHint="Try a different word, or fewer of them."
      />
    </div>
  );
};
